module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_FI-b632416a4b4b32f42e274e72e4cbeca3.svg";